import { ControllerPaletteColor } from './__palette-color';

export enum ControllerMenuItemColor {
  DefaultFg = ControllerPaletteColor.Gray100,
  HoverBg = ControllerPaletteColor.Ngb900,
  SelectedBg = ControllerPaletteColor.Ngb900,
  SecondaryFg = ControllerPaletteColor.Gray100,
  SecondaryHoverBg = ControllerPaletteColor.Gray900,
  SecondarySelectedBg = ControllerPaletteColor.Gray900,
}
